module.exports = __webpack_public_path__ + "media/application/images/svgs/server-fde3b0bafbec9ce119d4d11108d7bd54.svg";